var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:'label' +
            (_vm.isLabelLarge ? ' large' : '') +
            (_vm.isBold ? ' bold' : '') +
            (_vm.isDark ? ' dark' : '') +
            (_vm.isSlim ? ' slim' : '')},[(_vm.error)?_c('div',[_c('div',{staticClass:"input-error"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.removeSentenceEndingChar())}}),_vm._v(". ")])]):_c('div',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}}),(_vm.isOptional)?_c('span',[_vm._v(" ("+_vm._s(_vm.$t('optional'))+")")]):_vm._e(),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }